import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { checkTime } from "../constant/constant";
import "./home.css"
import { useDispatch,useSelector } from 'react-redux';
import { useNavigate } from "react-router-dom";
import { faBullhorn, faChartColumn, faPlay } from '@fortawesome/free-solid-svg-icons';
import { faWhatsapp } from '@fortawesome/free-brands-svg-icons';
import CommonModalPopup from "./CommonaModalPopUp";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { msgPromtsuccess } from "../features/userSlice";
const Home = () => {
    const { t } = useTranslation();
    const { all_games,Info} = useSelector((state) => state.users);
   const [openModal,setOpenModal]=useState(false);
   const [content_type,setcontent_type]=useState( {content:''});
   const dispatch=useDispatch();
   const navigate=useNavigate();
   const closeModal=()=>{
        setOpenModal(false);
   }
      const getMygameUrl=(name,market_status)=>{
        if(market_status){
         let newName=name.split(' ').join('_');
         navigate(`/game_type/${newName}`);
        }else{
          dispatch(msgPromtsuccess({msg:t('home.marketClosed'),error:true}));
          return false;
        }
      }


      const CommonModalOpener=(data)=>{
            setOpenModal(true);
            setcontent_type({
              content:data.TYPE,
              game_name:data.game_name,
              phone:data?.phone
            });
      }


    const supportNumbers = [Info?.helpNumber1, Info?.helpNumber2].filter(Boolean);
    return(
      <div className="hm-page">
        {Info?.notification_head && (
          <div className="hm-notice">
            <FontAwesomeIcon icon={faBullhorn} className="hm-notice-icon" />
            <span>{Info?.notification_head}</span>
          </div>
        )}

        {supportNumbers.length > 0 && (
          <div className="hm-support">
            {supportNumbers.map((phone) => (
              <button type="button" key={phone} className="hm-support-btn" onClick={()=>CommonModalOpener({TYPE:'CONNECT_SUPPORT',game_name:'',phone})}>
                <FontAwesomeIcon icon={faWhatsapp} className="hm-support-icon" />
                <span>+91{phone}</span>
              </button>
            ))}
          </div>
        )}

        <div className="hm-list">
          {all_games.map((data, index) => {
            const isOpen = data?.game_status!=='0' && checkTime(data.close_time);
            return (
              <div className="hm-game" key={index}>
                <div className="hm-game-top">
                  <div className="hm-game-info">
                    <h3 className="hm-game-name">{data.games_name}</h3>
                    <div className="hm-game-result">{data.open_pana}-{data.open_digit}{data.close_digit}-{data.close_pana}</div>
                  </div>
                  <button type="button" className="hm-chart-btn" aria-label={t('home.charts', { name: data.games_name })} onClick={()=>CommonModalOpener({TYPE:'CHART_INFO',game_name:data.games_name?.split(' ').join('_'),phone:Info?.helpNumber1})}>
                    <FontAwesomeIcon icon={faChartColumn} />
                  </button>
                </div>
                <span className={`hm-status ${isOpen ? 'is-open' : 'is-closed'}`}>
                  <span className="hm-status-dot" aria-hidden="true"></span>
                  {isOpen ? t('home.running') : t('home.closed')}
                </span>
                <div className="hm-game-bottom">
                  <div className="hm-times">
                    <div className="hm-time">
                      <span className="hm-time-label">{t('home.openBidsTill')}</span>
                      <span className="hm-time-value">{data.open_time}</span>
                    </div>
                    <div className="hm-time">
                      <span className="hm-time-label">{t('home.closeBidsTill')}</span>
                      <span className="hm-time-value">{data.close_time}</span>
                    </div>
                  </div>
                  {Info?.status==='1' && (
                    <button type="button" className={`hm-play${isOpen ? '' : ' is-closed'}`} aria-disabled={!isOpen} onClick={()=>getMygameUrl(data.games_name,isOpen)}>
                      <FontAwesomeIcon icon={faPlay} /> {t('home.play')}
                    </button>
                  )}
                </div>
              </div>
            );
          })}
        </div>

        <CommonModalPopup
        isOpen={openModal}
        closeModal={closeModal}
        data={content_type}
        />
    </div>
    )};

export default Home;